import type { ComponentMultiStyle } from "@yamada-ui/core"
import { mergeMultiStyle } from "@yamada-ui/core"
import { Slider } from "./slider"

export const RangeSlider: ComponentMultiStyle<"RangeSlider"> =
  mergeMultiStyle(Slider)()
